import styled from 'styled-components';
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';

export const SMarginTop = styled.div`
  height: 15%;
`;

export const SWrapper = styled.div`
  @media (min-width: 600px) {
    width: 100%;
    background-color: white;
  }
`;

export const SHeader = styled.div`
  height: 40%;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  padding-top: 3%;
  padding-bottom: 3%;
`;

export const SLogo = styled.div`
  height: 40%;
  padding-left: 15%;
`;

export const SArrowLeftIcon = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 22.5px;
  margin-bottom: 15px;
  cursor: pointer;
`;

export const STitleWrapperExt = styled.div`
  padding-left: 15%;
  padding-top: 3%;
`;

export const SGridWrapper = styled.div`
  padding: 3% 5%;
`;

export const SGridLayoutWrapper = styled(GridLayout)`
  width: 100%;
`;

export const SGridLayoutItemSmallPanel = styled(GridLayoutItem)`
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 10px;
  align-items: center;

  height: 360px;
  padding: 16px 16px;
  margin-right: 3px;
`;

export const SGridLayoutItemLargePanel = styled(GridLayoutItem)`
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 10px;
  align-items: center;

  width: 100%;
  height: 360px;
  padding: 16px 16px;
`;

export const SGridLayoutItemPanel = styled(GridLayoutItem)`
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 10px;
  align-items: center;

  // height: 360px;
  padding: 16px 16px;
  margin-right: 3px;
`;

export const SGridLayoutWrapper1 = styled(GridLayout)`
  width: 100%;
  padding-left: 14%;
  padding-top: 1%;
`;
